export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const monthIndex = String(date.getMonth() + 1).padStart(2, "0"); // Add 1 since months are 0-indexed in JavaScript
  const year = date.getFullYear();

  return `${year}-${monthIndex}-${day}`;
};
